import { actionGenerator, IReduxAction } from '../../../actionGenerator';

export const PUBLISH_TO_HIDDEN_BASE = 'PUBLISH_AVAILABLE :: PUBLISH_TO_HIDDEN_BASE';

export type TPublishToHiddenBaseAction = IReduxAction<typeof PUBLISH_TO_HIDDEN_BASE, boolean>;

export const publishToHiddenBase = actionGenerator<typeof PUBLISH_TO_HIDDEN_BASE, boolean>(PUBLISH_TO_HIDDEN_BASE);
